import React, { useEffect, useState } from "react";
import {
  getbusrepairlog,
  getBusRepairLogExport,
} from "../../services/TransportService";
import { Spinner } from "react-bootstrap";
import DataTable from "react-data-table-component";
import Pagination from "../Constant/Pagination";
import { CancelRequest } from "../../services/AxiosInstance";
import DebounceSearchInput from "../Constant/DebounceSearchInput";
import { useParams } from "react-router-dom";
import { PiExportBold } from "react-icons/pi";
import { Tooltip } from "@mui/material";
import { getBusStatusBadge } from "../../utilities";
import { format } from "date-fns";
import { Link } from "react-router-dom";
import { Offcanvas } from "react-bootstrap";
import { Card, Badge } from "react-bootstrap";
import { CustomTooltip } from "../../components/CustomTooltip";
import DebounceSmallSearchInput from "../Constant/DebounceSmallSearchInput";

const BusReplacementCard = ({ data }) => {
  const statusVariant =
    data?.status === "In Progress"
      ? "warning"
      : data?.status === "Completed"
      ? "success"
      : "secondary";

  const statusTextColor =
    data?.status === "In Progress" ? "text-dark" : "text-white";

  return (
    <Card className="shadow-sm mb-4 border-0">
      <Card.Header className="bg-light d-flex justify-content-between align-items-center border-bottom">
        <h5 className="mb-0 text-primary">
          🛠️ Replacement - {data?.replacement_type || "N/A"}
        </h5>
        <Badge bg={statusVariant} className={`px-3 py-1 ${statusTextColor}`}>
          {data?.status}
        </Badge>
      </Card.Header>

      <Card.Body>
        <div className="row">
          {/* Current Bus */}
          <div className="col-6 mb-4">
            <Card className="h-100 border-0 shadow-sm rounded-3 overflow-hidden">
              <div className="border-start border-4 border-primary p-3 bg-light h-100">
                <h6 className="text-primary fw-bold mb-2 d-flex align-items-center">
                  🚍 <span className="ms-1">Current Bus</span>
                </h6>
                <p className="mb-1">
                  <strong className="me-1">Number:</strong>
                  <span className="text-dark">
                    {data?.bus?.number_plate || "N/A"}
                  </span>
                </p>
                <p className="mb-0">
                  <strong className="me-1">Model:</strong>
                  <span className="text-dark">{data?.bus?.model || "N/A"}</span>
                </p>
              </div>
            </Card>
          </div>

          {/* Replaced With */}
          <div className="col-6 mb-4">
            <Card className="h-100 shadow-sm rounded-3 overflow-hidden">
              <div className="border-start border-4 border-success p-3 bg-light h-100">
                <h6 className="text-success fw-bold mb-2 d-flex align-items-center">
                  🔁 <span className="ms-1">Replaced With</span>
                </h6>
                <p className="mb-1">
                  <strong className="me-1">Number:</strong>
                  <span className="text-dark">
                    {data?.replaced_bus?.number_plate || "N/A"}
                  </span>
                </p>
                <p className="mb-0">
                  <strong className="me-1">Model:</strong>
                  <span className="text-dark">
                    {data?.replaced_bus?.model || "N/A"}
                  </span>
                </p>
              </div>
            </Card>
          </div>
        </div>

        <hr />

        <div className="mb-2">
          <strong>📄 Reason:</strong>{" "}
          <span className="text-dark">{data?.description || "N/A"}</span>
        </div>

        <div className="mb-2">
          <strong>📏 Distance This Month:</strong>{" "}
          <span className="badge bg-info text-dark fs-6">
            {data?.current_month_travel_distance || "-"} km
          </span>
        </div>

        <div className="mb-2">
          <strong>📅 Start Date:</strong>{" "}
          <span className="text-dark">
            {data.replacement_start_date
              ? format(
                  new Date(data.replacement_start_date),
                  "dd MMM yyyy, hh:mm a"
                )
              : "—"}
          </span>
        </div>

        <div className="mb-2">
          <strong>📅 End Date:</strong>{" "}
          <span className="text-dark">
            {data.replacement_end_date
              ? format(
                  new Date(data.replacement_end_date),
                  "dd MMM yyyy, hh:mm a"
                )
              : "—"}
          </span>
        </div>

        <div className="mb-2">
          <strong>👤 Action By:</strong>{" "}
          <span className="text-dark">
            {data.action_taken_by?.fullname || "N/A"}
          </span>
        </div>

        {data.cancelled_reason && (
          <div className="mt-3">
            <strong className="text-danger">❌ Cancelled Reason:</strong>{" "}
            <span className="text-danger">{data.cancelled_reason}</span>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

// const BusReplacementCard = ({ data }) => {
//   return (
//     <Card className="shadow-sm mb-3">
//       <Card.Header className="d-flex justify-content-between align-items-center bg-light">
//         <strong>Replacement - {data?.replacement_type}</strong>
//         <Badge
//           bg={
//             data.status === "In Progress"
//               ? "warning"
//               : data.status === "Completed"
//               ? "success"
//               : "secondary"
//           }
//           text={data?.status === "In Progress" ? "dark" : "white"}
//         >
//           {data.status}
//         </Badge>
//       </Card.Header>
//       <Card.Body>
//         <div className="row mb-2">
//           <div className="col-md-6">
//             <h6>🚍 Current Bus</h6>
//             <p className="mb-1">
//               <strong>Number:</strong>
//               <span className="text-dark">
//                 {data?.bus?.number_plate || "N/A"}
//               </span>
//             </p>
//             <p className="mb-0">
//               <strong>Model:</strong>
//               <span className="text-dark">{data?.bus?.model || "N/A"}</span>
//             </p>
//           </div>
//           <div className="col-md-6">
//             <h6>🔁 Replaced With</h6>
//             <p className="mb-1">
//               <strong>Number:</strong>
//               <span className="text-dark">
//                 {data?.replaced_bus?.number_plate || "N/A"}
//               </span>
//             </p>
//             <p className="mb-0">
//               <strong>Model:</strong>
//               <span className="text-dark">
//                 {data?.replaced_bus?.model || "N/A"}
//               </span>
//             </p>
//           </div>
//         </div>

//         <hr />

//         <p>
//           <strong>Reason:</strong>{" "}
//           <span className="text-dark">{data?.description || "N/A"}</span>
//         </p>
//         <p>
//           <strong>Distance This Month:</strong>{" "}
//           <span className="text-dark">
//             {" "}
//             {data?.current_month_travel_distance || "-"} km
//           </span>
//         </p>
//         <p>
//           <strong>Start Date:</strong>{" "}
//           <span className="text-dark">
//             {" "}
//             {data.replacement_start_date
//               ? format(
//                   new Date(data.replacement_start_date),
//                   "dd MMM yyyy, hh:mm a"
//                 )
//               : "—"}
//           </span>
//         </p>
//         <p>
//           <strong>End Date:</strong>{" "}
//           <span className="text-dark">
//             {data.replacement_end_date
//               ? format(
//                   new Date(data.replacement_end_date),
//                   "dd MMM yyyy, hh:mm a"
//                 )
//               : "—"}
//           </span>
//         </p>
//         <p>
//           <strong>Action By:</strong>
//           <span className="text-dark">
//             {data.action_taken_by?.fullname || "N/A"}
//           </span>
//         </p>
//         {data.cancelled_reason && (
//           <p className="text-danger">
//             <strong>Cancelled Reason:</strong> {data?.cancelled_reason || "N/A"}
//           </p>
//         )}
//       </Card.Body>
//     </Card>
//   );
// };

const BusReplacementLog = ({ busId }) => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [exportloading, setExportloading] = useState(false);
  const [sidebar, setSidebar] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [param, setParam] = useState({
    query: "",
    // start_date: format(subDays(new Date(), 7), "yyyy-MM-dd"),
    // end_date: format(new Date(), "yyyy-MM-dd"),
    page: "1",
    page_size: "10",
  });
  const getdata = () => {
    setLoading(true);
    getbusrepairlog(busId || id, param)
      .then((res) => {
        setData(res?.data?.results);
        setTotal(res.data?.count || 0);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getdata();
  }, [param, id, busId]);
  const handlePageChange = (page) => {
    setParam((prev) => ({
      ...prev,
      page: page.selected + 1,
    }));
  };
  const handleSearchChange = (value) => {
    if (value.length > 0) CancelRequest();
    setParam((prev) => ({
      ...prev,
      query: value,
      page: 1,
    }));
  };
  const handleexport = () => {
    setExportloading(true);
    const newparam = { ...param, export: true };
    getBusRepairLogExport(id, newparam)
      .then((res) => {
        const blob = new Blob([res.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = "Repair Log.xlsx"; // set your desired filename
        a.click();

        window.URL.revokeObjectURL(url); // clean up
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setExportloading(false);
      });
  };
  return (
    <div>
      <div className="d-flex justify-content-end px-1 mb-2">
        <div className="d-flex gap-1">
          <DebounceSearchInput handleSearchChange={handleSearchChange} />
          <CustomTooltip title="Export" arrow>
            <span
              className="me-2 cursor-pointer d-inline-flex align-items-center justify-content-center bus-action-button"
              style={{ padding: "11px" }}
              onClick={handleexport}
              // style={{
              //   padding: "0px 15px",
              //   backgroundColor: "rgb(226, 225, 225)",
              //   borderRadius: "5px",
              // }}
              // style={{ width: "24px", height: "24px" }}
            >
              {exportloading ? (
                <Spinner animation="border" variant="primary" size="sm" />
              ) : (
                <PiExportBold size={18} />
              )}
            </span>
          </CustomTooltip>
        </div>
      </div>

      {loading ? (
        <div className="text-center my-4">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : data.length === 0 ? (
        <div className="p-2 text-center">There are no records found.</div>
      ) : (
        <div className="table-responsive">
          <table className="table table-hover fs-6 align-middle mb-0">
            <thead className="custom-thead table-light">
              <tr>
                <th>Replace Bus</th>
                <th>Purpose</th>
                <th>Start Date</th>
                <th>End Date</th>
                <th>Taken By</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {data.map((row, idx) => {
                const status = row.status?.toLowerCase();
                const badgeClass =
                  {
                    "in progress": "badge bg-warning text-dark",
                    completed: "badge bg-success",
                    pending: "badge bg-secondary",
                    cancelled: "badge bg-danger",
                  }[status] || "badge bg-light text-dark";

                return (
                  <tr
                    key={idx}
                    onClick={() => {
                      setSelectedData(row);
                      setSidebar(true);
                    }}
                    className="cursor-pointer"
                  >
                    <td>
                      <Link
                        to={`/bus/${row?.replaced_bus?.id}`}
                        className="text-uppercase fw-semibold text-primary d-block"
                      >
                        {row?.replaced_bus?.number_plate || "N/A"}
                      </Link>
                    </td>
                    <td>
                      {row?.replacement_type ? (
                        <span
                          className={getBusStatusBadge(row?.replacement_type)}
                        >
                          {row?.replacement_type}
                        </span>
                      ) : (
                        "N/A"
                      )}
                    </td>
                    <td>
                      {row?.replacement_start_date
                        ? format(row?.replacement_start_date, "dd MMM,yy")
                        : "—"}
                    </td>
                    <td>
                      {row?.replacement_end_date
                        ? format(row?.replacement_end_date, "dd MMM,yy")
                        : "—"}
                    </td>
                    <td>{row.action_taken_by?.fullname || "N/A"}</td>
                    <td>
                      <span className={badgeClass}>{row?.status || "N/A"}</span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {/* Pagination */}
      {!loading && data && data.length > 0 && (
        <div className="px-2 border-top">
          <Pagination
            currentPage={param.page}
            recordsPage={param.page_size}
            dataLength={total}
            handlePagination={handlePageChange}
          />
        </div>
      )}
      <Offcanvas
        show={sidebar}
        onHide={() => setSidebar(false)}
        placement="end"
        style={{
          width: window.innerWidth < 768 ? "100vw" : "500px",
          height: window.innerWidth < 768 ? "100vh" : "auto",
          borderRadius: window.innerWidth < 768 ? "0" : undefined,
        }}
      >
        <Offcanvas.Header className="border-bottom p-3" closeButton>
          <h5 className="p-0 m-0">Replacement Log</h5>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-2">
          <BusReplacementCard data={selectedData} />
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};

export default BusReplacementLog;
